/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var StackHDownIcon20Solid = forwardRef('StackHDownIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M7 1.25a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5H7Z" }),
        React.createElement("path", { d: "M4.25 5A.75.75 0 0 1 5 4.25h10a.75.75 0 0 1 0 1.5H5A.75.75 0 0 1 4.25 5Z" }),
        React.createElement("path", { d: "M2 10a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v5a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3v-5Z" })));
});
